import { render, staticRenderFns } from "./GameListScroll.vue?vue&type=template&id=389b4420&scoped=true"
import script from "./GameListScroll.vue?vue&type=script&lang=js"
export * from "./GameListScroll.vue?vue&type=script&lang=js"
import style0 from "./GameListScroll.vue?vue&type=style&index=0&id=389b4420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389b4420",
  null
  
)

export default component.exports